// Generated from /src/shared/components/internal/Filter/serialization/SearchSyntax.g4 by ANTLR 4.9.3
// jshint ignore: start
import antlr4 from 'antlr4';

const serializedATN = [
  '\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786',
  '\u5964\u0002\u0019\u0120\b\u0001\u0004\u0002\t\u0002\u0004\u0003\t\u0003',
  '\u0004\u0004\t\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007',
  '\t\u0007\u0004\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0004',
  '\f\t\f\u0004\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004\u0010',
  '\t\u0010\u0004\u0011\t\u0011\u0004\u0012\t\u0012\u0004\u0013\t\u0013',
  '\u0004\u0014\t\u0014\u0004\u0015\t\u0015\u0004\u0016\t\u0016\u0004\u0017',
  '\t\u0017\u0004\u0018\t\u0018\u0004\u0019\t\u0019\u0004\u001a\t\u001a',
  '\u0004\u001b\t\u001b\u0004\u001c\t\u001c\u0004\u001d\t\u001d\u0004\u001e',
  '\t\u001e\u0004\u001f\t\u001f\u0004 \t \u0004!\t!\u0004"\t"\u0004#',
  "\t#\u0004$\t$\u0004%\t%\u0004&\t&\u0004'\t'\u0003\u0002\u0003\u0002",
  '\u0003\u0003\u0003\u0003\u0003\u0004\u0003\u0004\u0003\u0005\u0003\u0005',
  '\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0007',
  '\u0003\u0007\u0003\u0007\u0003\u0007\u0003\b\u0003\b\u0003\b\u0003\b',
  '\u0003\t\u0003\t\u0003\n\u0006\nh\n\n\r\n\u000e\ni\u0003\n\u0003\n\u0006',
  '\nn\n\n\r\n\u000e\no\u0007\nr\n\n\f\n\u000e\nu\u000b\n\u0003\n\u0003',
  '\n\u0003\u000b\u0003\u000b\u0003\f\u0003\f\u0003\r\u0003\r\u0003\u000e',
  '\u0003\u000e\u0003\u000f\u0003\u000f\u0003\u000f\u0003\u000f\u0003\u0010',
  '\u0003\u0010\u0003\u0011\u0003\u0011\u0003\u0011\u0003\u0011\u0003\u0011',
  '\u0003\u0011\u0003\u0011\u0003\u0011\u0003\u0011\u0003\u0011\u0003\u0011',
  '\u0003\u0012\u0003\u0012\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013',
  '\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013',
  '\u0003\u0013\u0003\u0013\u0003\u0013\u0005\u0013\u00a1\n\u0013\u0003',
  '\u0013\u0005\u0013\u00a4\n\u0013\u0003\u0014\u0003\u0014\u0003\u0014',
  '\u0003\u0014\u0003\u0014\u0003\u0014\u0003\u0014\u0003\u0014\u0005\u0014',
  '\u00ae\n\u0014\u0003\u0015\u0003\u0015\u0003\u0016\u0003\u0016\u0003',
  '\u0017\u0003\u0017\u0003\u0018\u0003\u0018\u0003\u0019\u0003\u0019\u0003',
  '\u001a\u0003\u001a\u0003\u001b\u0003\u001b\u0003\u001c\u0003\u001c\u0003',
  '\u001c\u0003\u001c\u0003\u001c\u0005\u001c\u00c3\n\u001c\u0003\u001d',
  '\u0003\u001d\u0003\u001d\u0003\u001e\u0003\u001e\u0005\u001e\u00ca\n',
  '\u001e\u0003\u001f\u0005\u001f\u00cd\n\u001f\u0003\u001f\u0005\u001f',
  '\u00d0\n\u001f\u0003\u001f\u0003\u001f\u0003\u001f\u0003 \u0005 \u00d6',
  '\n \u0003 \u0006 \u00d9\n \r \u000e \u00da\u0003!\u0003!\u0003!\u0003',
  '!\u0007!\u00e1\n!\f!\u000e!\u00e4\u000b!\u0003!\u0003!\u0003"\u0006',
  '"\u00e9\n"\r"\u000e"\u00ea\u0003"\u0003"\u0006"\u00ef\n"\r"',
  '\u000e"\u00f0\u0003"\u0003"\u0006"\u00f5\n"\r"\u000e"\u00f6\u0003',
  '"\u0003"\u0006"\u00fb\n"\r"\u000e"\u00fc\u0003"\u0003"\u0006',
  '"\u0101\n"\r"\u000e"\u0102\u0005"\u0105\n"\u0003#\u0006#\u0108',
  '\n#\r#\u000e#\u0109\u0003#\u0003#\u0006#\u010e\n#\r#\u000e#\u010f\u0007',
  '#\u0112\n#\f#\u000e#\u0115\u000b#\u0003$\u0003$\u0003$\u0003$\u0003',
  "%\u0003%\u0003&\u0003&\u0003'\u0003'\u0002\u0002(\u0003\u0003\u0005",
  '\u0004\u0007\u0005\t\u0006\u000b\u0007\r\b\u000f\t\u0011\n\u0013\u000b',
  '\u0015\f\u0017\r\u0019\u000e\u001b\u000f\u001d\u0002\u001f\u0002!\u0002',
  "#\u0002%\u0002'\u0002)\u0002+\u0002-\u0002/\u00021\u00023\u00025\u0002",
  '7\u00109\u0011;\u0012=\u0013?\u0014A\u0015C\u0016E\u0017G\u0018I\u0002',
  'K\u0002M\u0019\u0003\u0002\r\u0004\u0002--//\b\u0002FFOO[[jjoouu\u0003',
  '\u000224\u0003\u000227\u0003\u000223\u0003\u000225\u0004\u0002>>@@\u0003',
  '\u0002$$\u0003\u00022;\u0006\u00022;C\\aac|\u0006\u0002\u000b\f\u000f',
  '\u000f""..\u0002\u0128\u0002\u0003\u0003\u0002\u0002\u0002\u0002\u0005',
  '\u0003\u0002\u0002\u0002\u0002\u0007\u0003\u0002\u0002\u0002\u0002\t',
  '\u0003\u0002\u0002\u0002\u0002\u000b\u0003\u0002\u0002\u0002\u0002\r',
  '\u0003\u0002\u0002\u0002\u0002\u000f\u0003\u0002\u0002\u0002\u0002\u0011',
  '\u0003\u0002\u0002\u0002\u0002\u0013\u0003\u0002\u0002\u0002\u0002\u0015',
  '\u0003\u0002\u0002\u0002\u0002\u0017\u0003\u0002\u0002\u0002\u0002\u0019',
  '\u0003\u0002\u0002\u0002\u0002\u001b\u0003\u0002\u0002\u0002\u00027',
  '\u0003\u0002\u0002\u0002\u00029\u0003\u0002\u0002\u0002\u0002;\u0003',
  '\u0002\u0002\u0002\u0002=\u0003\u0002\u0002\u0002\u0002?\u0003\u0002',
  '\u0002\u0002\u0002A\u0003\u0002\u0002\u0002\u0002C\u0003\u0002\u0002',
  '\u0002\u0002E\u0003\u0002\u0002\u0002\u0002G\u0003\u0002\u0002\u0002',
  '\u0002M\u0003\u0002\u0002\u0002\u0003O\u0003\u0002\u0002\u0002\u0005',
  'Q\u0003\u0002\u0002\u0002\u0007S\u0003\u0002\u0002\u0002\tU\u0003\u0002',
  '\u0002\u0002\u000bW\u0003\u0002\u0002\u0002\r\\\u0003\u0002\u0002\u0002',
  '\u000f`\u0003\u0002\u0002\u0002\u0011d\u0003\u0002\u0002\u0002\u0013',
  'g\u0003\u0002\u0002\u0002\u0015x\u0003\u0002\u0002\u0002\u0017z\u0003',
  '\u0002\u0002\u0002\u0019|\u0003\u0002\u0002\u0002\u001b~\u0003\u0002',
  '\u0002\u0002\u001d\u0080\u0003\u0002\u0002\u0002\u001f\u0084\u0003\u0002',
  '\u0002\u0002!\u0086\u0003\u0002\u0002\u0002#\u0091\u0003\u0002\u0002',
  "\u0002%\u0093\u0003\u0002\u0002\u0002'\u00ad\u0003\u0002\u0002\u0002",
  ')\u00af\u0003\u0002\u0002\u0002+\u00b1\u0003\u0002\u0002\u0002-\u00b3',
  '\u0003\u0002\u0002\u0002/\u00b5\u0003\u0002\u0002\u00021\u00b7\u0003',
  '\u0002\u0002\u00023\u00b9\u0003\u0002\u0002\u00025\u00bb\u0003\u0002',
  '\u0002\u00027\u00c2\u0003\u0002\u0002\u00029\u00c4\u0003\u0002\u0002',
  '\u0002;\u00c9\u0003\u0002\u0002\u0002=\u00cc\u0003\u0002\u0002\u0002',
  '?\u00d5\u0003\u0002\u0002\u0002A\u00dc\u0003\u0002\u0002\u0002C\u00e8',
  '\u0003\u0002\u0002\u0002E\u0107\u0003\u0002\u0002\u0002G\u0116\u0003',
  '\u0002\u0002\u0002I\u011a\u0003\u0002\u0002\u0002K\u011c\u0003\u0002',
  '\u0002\u0002M\u011e\u0003\u0002\u0002\u0002OP\u0007/\u0002\u0002P\u0004',
  '\u0003\u0002\u0002\u0002QR\u0007*\u0002\u0002R\u0006\u0003\u0002\u0002',
  '\u0002ST\u0007+\u0002\u0002T\b\u0003\u0002\u0002\u0002UV\u0007.\u0002',
  '\u0002V\n\u0003\u0002\u0002\u0002WX\u0007p\u0002\u0002XY\u0007w\u0002',
  '\u0002YZ\u0007n\u0002\u0002Z[\u0007n\u0002\u0002[\f\u0003\u0002\u0002',
  '\u0002\\]\u0007P\u0002\u0002]^\u0007Q\u0002\u0002^_\u0007Y\u0002\u0002',
  '_\u000e\u0003\u0002\u0002\u0002`a\t\u0002\u0002\u0002ab\u0005;\u001e',
  '\u0002bc\u0005\u0011\t\u0002c\u0010\u0003\u0002\u0002\u0002de\t\u0003',
  '\u0002\u0002e\u0012\u0003\u0002\u0002\u0002fh\u0005K&\u0002gf\u0003',
  '\u0002\u0002\u0002hi\u0003\u0002\u0002\u0002ig\u0003\u0002\u0002\u0002',
  'ij\u0003\u0002\u0002\u0002js\u0003\u0002\u0002\u0002km\u00070\u0002',
  '\u0002ln\u0005K&\u0002ml\u0003\u0002\u0002\u0002no\u0003\u0002\u0002',
  '\u0002om\u0003\u0002\u0002\u0002op\u0003\u0002\u0002\u0002pr\u0003\u0002',
  '\u0002\u0002qk\u0003\u0002\u0002\u0002ru\u0003\u0002\u0002\u0002sq\u0003',
  '\u0002\u0002\u0002st\u0003\u0002\u0002\u0002tv\u0003\u0002\u0002\u0002',
  'us\u0003\u0002\u0002\u0002vw\u0005G$\u0002w\u0014\u0003\u0002\u0002',
  '\u0002xy\u0005!\u0011\u0002y\u0016\u0003\u0002\u0002\u0002z{\u0005\u001d',
  '\u000f\u0002{\u0018\u0003\u0002\u0002\u0002|}\u00071\u0002\u0002}\u001a',
  "\u0003\u0002\u0002\u0002~\u007f\u0005'\u0014\u0002\u007f\u001c\u0003",
  '\u0002\u0002\u0002\u0080\u0081\u0005!\u0011\u0002\u0081\u0082\u0005',
  '\u001f\u0010\u0002\u0082\u0083\u0005%\u0013\u0002\u0083\u001e\u0003',
  '\u0002\u0002\u0002\u0084\u0085\u0007V\u0002\u0002\u0085 \u0003\u0002',
  '\u0002\u0002\u0086\u0087\u0005I%\u0002\u0087\u0088\u0005I%\u0002\u0088',
  '\u0089\u0005I%\u0002\u0089\u008a\u0005I%\u0002\u008a\u008b\u0005#\u0012',
  '\u0002\u008b\u008c\u00053\u001a\u0002\u008c\u008d\u0005I%\u0002\u008d',
  '\u008e\u0005#\u0012\u0002\u008e\u008f\u00055\u001b\u0002\u008f\u0090',
  '\u0005I%\u0002\u0090"\u0003\u0002\u0002\u0002\u0091\u0092\u0007/\u0002',
  '\u0002\u0092$\u0003\u0002\u0002\u0002\u0093\u0094\u0005-\u0017\u0002',
  '\u0094\u0095\u0005I%\u0002\u0095\u0096\u0005)\u0015\u0002\u0096\u0097',
  '\u0005/\u0018\u0002\u0097\u0098\u0005I%\u0002\u0098\u0099\u0005)\u0015',
  '\u0002\u0099\u009a\u00051\u0019\u0002\u009a\u00a0\u0005I%\u0002\u009b',
  '\u009c\u0005+\u0016\u0002\u009c\u009d\u0005I%\u0002\u009d\u009e\u0005',
  'I%\u0002\u009e\u009f\u0005I%\u0002\u009f\u00a1\u0003\u0002\u0002\u0002',
  '\u00a0\u009b\u0003\u0002\u0002\u0002\u00a0\u00a1\u0003\u0002\u0002\u0002',
  "\u00a1\u00a3\u0003\u0002\u0002\u0002\u00a2\u00a4\u0005'\u0014\u0002",
  '\u00a3\u00a2\u0003\u0002\u0002\u0002\u00a3\u00a4\u0003\u0002\u0002\u0002',
  '\u00a4&\u0003\u0002\u0002\u0002\u00a5\u00ae\u0007\\\u0002\u0002\u00a6',
  '\u00a7\t\u0002\u0002\u0002\u00a7\u00a8\u0005-\u0017\u0002\u00a8\u00a9',
  '\u0005I%\u0002\u00a9\u00aa\u0005)\u0015\u0002\u00aa\u00ab\u0005/\u0018',
  '\u0002\u00ab\u00ac\u0005I%\u0002\u00ac\u00ae\u0003\u0002\u0002\u0002',
  '\u00ad\u00a5\u0003\u0002\u0002\u0002\u00ad\u00a6\u0003\u0002\u0002\u0002',
  '\u00ae(\u0003\u0002\u0002\u0002\u00af\u00b0\u0007<\u0002\u0002\u00b0',
  '*\u0003\u0002\u0002\u0002\u00b1\u00b2\u00070\u0002\u0002\u00b2,\u0003',
  '\u0002\u0002\u0002\u00b3\u00b4\t\u0004\u0002\u0002\u00b4.\u0003\u0002',
  '\u0002\u0002\u00b5\u00b6\t\u0005\u0002\u0002\u00b60\u0003\u0002\u0002',
  '\u0002\u00b7\u00b8\t\u0005\u0002\u0002\u00b82\u0003\u0002\u0002\u0002',
  '\u00b9\u00ba\t\u0006\u0002\u0002\u00ba4\u0003\u0002\u0002\u0002\u00bb',
  '\u00bc\t\u0007\u0002\u0002\u00bc6\u0003\u0002\u0002\u0002\u00bd\u00be',
  '\u0007@\u0002\u0002\u00be\u00c3\u0007?\u0002\u0002\u00bf\u00c0\u0007',
  '>\u0002\u0002\u00c0\u00c3\u0007?\u0002\u0002\u00c1\u00c3\t\b\u0002\u0002',
  '\u00c2\u00bd\u0003\u0002\u0002\u0002\u00c2\u00bf\u0003\u0002\u0002\u0002',
  '\u00c2\u00c1\u0003\u0002\u0002\u0002\u00c38\u0003\u0002\u0002\u0002',
  '\u00c4\u00c5\u00070\u0002\u0002\u00c5\u00c6\u00070\u0002\u0002\u00c6',
  ':\u0003\u0002\u0002\u0002\u00c7\u00ca\u0005? \u0002\u00c8\u00ca\u0005',
  '=\u001f\u0002\u00c9\u00c7\u0003\u0002\u0002\u0002\u00c9\u00c8\u0003',
  '\u0002\u0002\u0002\u00ca<\u0003\u0002\u0002\u0002\u00cb\u00cd\u0007',
  '/\u0002\u0002\u00cc\u00cb\u0003\u0002\u0002\u0002\u00cc\u00cd\u0003',
  '\u0002\u0002\u0002\u00cd\u00cf\u0003\u0002\u0002\u0002\u00ce\u00d0\u0005',
  '? \u0002\u00cf\u00ce\u0003\u0002\u0002\u0002\u00cf\u00d0\u0003\u0002',
  '\u0002\u0002\u00d0\u00d1\u0003\u0002\u0002\u0002\u00d1\u00d2\u00070',
  '\u0002\u0002\u00d2\u00d3\u0005? \u0002\u00d3>\u0003\u0002\u0002\u0002',
  '\u00d4\u00d6\u0007/\u0002\u0002\u00d5\u00d4\u0003\u0002\u0002\u0002',
  '\u00d5\u00d6\u0003\u0002\u0002\u0002\u00d6\u00d8\u0003\u0002\u0002\u0002',
  '\u00d7\u00d9\u0005I%\u0002\u00d8\u00d7\u0003\u0002\u0002\u0002\u00d9',
  '\u00da\u0003\u0002\u0002\u0002\u00da\u00d8\u0003\u0002\u0002\u0002\u00da',
  '\u00db\u0003\u0002\u0002\u0002\u00db@\u0003\u0002\u0002\u0002\u00dc',
  '\u00e2\u0007$\u0002\u0002\u00dd\u00e1\n\t\u0002\u0002\u00de\u00df\u0007',
  '^\u0002\u0002\u00df\u00e1\u0007$\u0002\u0002\u00e0\u00dd\u0003\u0002',
  '\u0002\u0002\u00e0\u00de\u0003\u0002\u0002\u0002\u00e1\u00e4\u0003\u0002',
  '\u0002\u0002\u00e2\u00e0\u0003\u0002\u0002\u0002\u00e2\u00e3\u0003\u0002',
  '\u0002\u0002\u00e3\u00e5\u0003\u0002\u0002\u0002\u00e4\u00e2\u0003\u0002',
  '\u0002\u0002\u00e5\u00e6\u0007$\u0002\u0002\u00e6B\u0003\u0002\u0002',
  '\u0002\u00e7\u00e9\u0005I%\u0002\u00e8\u00e7\u0003\u0002\u0002\u0002',
  '\u00e9\u00ea\u0003\u0002\u0002\u0002\u00ea\u00e8\u0003\u0002\u0002\u0002',
  '\u00ea\u00eb\u0003\u0002\u0002\u0002\u00eb\u00ec\u0003\u0002\u0002\u0002',
  '\u00ec\u00ee\u00070\u0002\u0002\u00ed\u00ef\u0005I%\u0002\u00ee\u00ed',
  '\u0003\u0002\u0002\u0002\u00ef\u00f0\u0003\u0002\u0002\u0002\u00f0\u00ee',
  '\u0003\u0002\u0002\u0002\u00f0\u00f1\u0003\u0002\u0002\u0002\u00f1\u00f2',
  '\u0003\u0002\u0002\u0002\u00f2\u00f4\u00070\u0002\u0002\u00f3\u00f5',
  '\u0005I%\u0002\u00f4\u00f3\u0003\u0002\u0002\u0002\u00f5\u00f6\u0003',
  '\u0002\u0002\u0002\u00f6\u00f4\u0003\u0002\u0002\u0002\u00f6\u00f7\u0003',
  '\u0002\u0002\u0002\u00f7\u00f8\u0003\u0002\u0002\u0002\u00f8\u00fa\u0007',
  '0\u0002\u0002\u00f9\u00fb\u0005I%\u0002\u00fa\u00f9\u0003\u0002\u0002',
  '\u0002\u00fb\u00fc\u0003\u0002\u0002\u0002\u00fc\u00fa\u0003\u0002\u0002',
  '\u0002\u00fc\u00fd\u0003\u0002\u0002\u0002\u00fd\u0104\u0003\u0002\u0002',
  '\u0002\u00fe\u0100\u00071\u0002\u0002\u00ff\u0101\u0005I%\u0002\u0100',
  '\u00ff\u0003\u0002\u0002\u0002\u0101\u0102\u0003\u0002\u0002\u0002\u0102',
  '\u0100\u0003\u0002\u0002\u0002\u0102\u0103\u0003\u0002\u0002\u0002\u0103',
  '\u0105\u0003\u0002\u0002\u0002\u0104\u00fe\u0003\u0002\u0002\u0002\u0104',
  '\u0105\u0003\u0002\u0002\u0002\u0105D\u0003\u0002\u0002\u0002\u0106',
  '\u0108\u0005K&\u0002\u0107\u0106\u0003\u0002\u0002\u0002\u0108\u0109',
  '\u0003\u0002\u0002\u0002\u0109\u0107\u0003\u0002\u0002\u0002\u0109\u010a',
  '\u0003\u0002\u0002\u0002\u010a\u0113\u0003\u0002\u0002\u0002\u010b\u010d',
  '\u00070\u0002\u0002\u010c\u010e\u0005K&\u0002\u010d\u010c\u0003\u0002',
  '\u0002\u0002\u010e\u010f\u0003\u0002\u0002\u0002\u010f\u010d\u0003\u0002',
  '\u0002\u0002\u010f\u0110\u0003\u0002\u0002\u0002\u0110\u0112\u0003\u0002',
  '\u0002\u0002\u0111\u010b\u0003\u0002\u0002\u0002\u0112\u0115\u0003\u0002',
  '\u0002\u0002\u0113\u0111\u0003\u0002\u0002\u0002\u0113\u0114\u0003\u0002',
  '\u0002\u0002\u0114F\u0003\u0002\u0002\u0002\u0115\u0113\u0003\u0002',
  '\u0002\u0002\u0116\u0117\u0007<\u0002\u0002\u0117\u0118\u0003\u0002',
  '\u0002\u0002\u0118\u0119\b$\u0002\u0002\u0119H\u0003\u0002\u0002\u0002',
  '\u011a\u011b\t\n\u0002\u0002\u011bJ\u0003\u0002\u0002\u0002\u011c\u011d',
  '\t\u000b\u0002\u0002\u011dL\u0003\u0002\u0002\u0002\u011e\u011f\t\f',
  '\u0002\u0002\u011fN\u0003\u0002\u0002\u0002\u001a\u0002ios\u00a0\u00a3',
  '\u00ad\u00c2\u00c9\u00cc\u00cf\u00d5\u00da\u00e0\u00e2\u00ea\u00f0\u00f6',
  '\u00fc\u0102\u0104\u0109\u010f\u0113\u0003\u0002\u0003\u0002',
].join('');

const atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

const decisionsToDFA = atn.decisionToState.map(
  (ds, index) => new antlr4.dfa.DFA(ds, index)
);

export class SearchSyntaxLexer extends antlr4.Lexer {
  static grammarFileName = 'SearchSyntax.g4';
  static channelNames = ['DEFAULT_TOKEN_CHANNEL', 'HIDDEN'];
  static modeNames = ['DEFAULT_MODE'];
  static literalNames = [
    null,
    "'-'",
    "'('",
    "')'",
    "','",
    "'null'",
    "'NOW'",
    null,
    null,
    null,
    null,
    null,
    "'/'",
    null,
    null,
    "'..'",
    null,
    null,
    null,
    null,
    null,
    null,
    "':'",
  ];

  static symbolicNames = [
    null,
    'NEGATION',
    'OPEN_PAR',
    'CLOSE_PAR',
    'COMMA',
    'NULL',
    'DATETIME_FN',
    'DATETIME_MATH',
    'DATETIME_UNIT',
    'FIELD_MATCH',
    'DATE',
    'DATETIME',
    'DATETIME_ROUNDER',
    'TIMEZONE',
    'COMPARATOR',
    'RANGE_OP',
    'NUMBER',
    'DECIMAL',
    'INTEGER',
    'STRING',
    'IP',
    'WORD',
    'MATCH_OP',
    'WS',
  ];

  static ruleNames = [
    'NEGATION',
    'OPEN_PAR',
    'CLOSE_PAR',
    'COMMA',
    'NULL',
    'DATETIME_FN',
    'DATETIME_MATH',
    'DATETIME_UNIT',
    'FIELD_MATCH',
    'DATE',
    'DATETIME',
    'DATETIME_ROUNDER',
    'TIMEZONE',
    'DATETIME_LITERAL',
    'DATETIME_SEP',
    'DATE_LITERAL',
    'DAY_SEP',
    'TIME_LITERAL',
    'TIMEZONE_LITERAL',
    'TIME_SEP',
    'MILLISECOND_SEP',
    'HOUR_LEAD',
    'MINUTE_LEAD',
    'SECOND_LEAD',
    'MONTH_LEAD',
    'DAY_LEAD',
    'COMPARATOR',
    'RANGE_OP',
    'NUMBER',
    'DECIMAL',
    'INTEGER',
    'STRING',
    'IP',
    'WORD',
    'MATCH_OP',
    'DIGIT',
    'WORD_CHAR',
    'WS',
  ];

  constructor(input) {
    super(input);
    this._interp = new antlr4.atn.LexerATNSimulator(
      this,
      atn,
      decisionsToDFA,
      new antlr4.PredictionContextCache()
    );
  }

  get atn() {
    return atn;
  }
}

SearchSyntaxLexer.EOF = antlr4.Token.EOF;
SearchSyntaxLexer.NEGATION = 1;
SearchSyntaxLexer.OPEN_PAR = 2;
SearchSyntaxLexer.CLOSE_PAR = 3;
SearchSyntaxLexer.COMMA = 4;
SearchSyntaxLexer.NULL = 5;
SearchSyntaxLexer.DATETIME_FN = 6;
SearchSyntaxLexer.DATETIME_MATH = 7;
SearchSyntaxLexer.DATETIME_UNIT = 8;
SearchSyntaxLexer.FIELD_MATCH = 9;
SearchSyntaxLexer.DATE = 10;
SearchSyntaxLexer.DATETIME = 11;
SearchSyntaxLexer.DATETIME_ROUNDER = 12;
SearchSyntaxLexer.TIMEZONE = 13;
SearchSyntaxLexer.COMPARATOR = 14;
SearchSyntaxLexer.RANGE_OP = 15;
SearchSyntaxLexer.NUMBER = 16;
SearchSyntaxLexer.DECIMAL = 17;
SearchSyntaxLexer.INTEGER = 18;
SearchSyntaxLexer.STRING = 19;
SearchSyntaxLexer.IP = 20;
SearchSyntaxLexer.WORD = 21;
SearchSyntaxLexer.MATCH_OP = 22;
SearchSyntaxLexer.WS = 23;
